<div class="subject-facet-wrapper" *ngIf="!!options.length">
    <div class="facet-title selenium-facet-title" (click)="onToggle()">
        <span class="toggle visible">
            <i
                class="fas"
                [ngClass]="{ 'fa-plus': isCollapsed, 'fa-minus': !isCollapsed }"
            ></i>
        </span>
        {{ title }}
        <span *ngIf="selectedFiltersCount">({{ selectedFiltersCount }})</span>
    </div>
    <div
        class="facet-content"
        [ngClass]="{ hidden: isCollapsed, grid: layout === 'grid' }"
    >
        <div class="options-wrapper selenium-facet-options">
            <div class="option" *ngFor="let option of options">
                <input
                    type="checkbox"
                    [id]="option.id || option.label"
                    [attr.data-gtmlabel]="title + ' - ' + option.label"
                    [ngModel]="option.checked"
                    (change)="onCheckboxChange($event, option)"
                />
                <label [for]="option.id || option.label">{{
                    option.label
                }}</label>
            </div>
            <div class="option" *ngFor="let option of fakeOptions"></div>
        </div>
    </div>
</div>
